var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgStyleQuestion = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#style-question_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.51.788A7.712 7.712 0 0 0 .796 8.5c0 1.36.366 2.631.97 3.748.774 1.428 3.758-4.042 5.35-2.85 1.591 1.192-3.78 5.073-2.288 5.869 1.102.587 2.345.945 3.68.945a7.712 7.712 0 0 0 0-15.424Z",
    fill: "#E5AA6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.089 14.612c-.756 0-1.368-.549-1.368-1.226 0-.677.612-1.226 1.368-1.226.755 0 1.367.55 1.367 1.226 0 .677-.612 1.226-1.367 1.226Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.123 9.852c.398.61.188 1.451-.468 1.878-.657.427-1.51.279-1.907-.331-.398-.61-.188-1.45.468-1.878.656-.427 1.51-.279 1.907.331Z",
    fill: "#FFD469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.35 5.472c.05.726-.543 1.358-1.324 1.412-.78.054-1.454-.491-1.504-1.218-.05-.726.542-1.358 1.323-1.412.781-.053 1.455.492 1.505 1.218Z",
    fill: "#0074A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.494 3.636c.05.726-.675 1.368-1.62 1.433-.945.064-1.752-.472-1.802-1.198-.05-.726.676-1.367 1.62-1.432.946-.065 1.752.47 1.802 1.197Z",
    fill: "#FF473E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.37 6.79c.05.727-.543 1.359-1.324 1.413-.781.053-1.455-.492-1.505-1.218-.05-.726.543-1.358 1.324-1.412.78-.054 1.455.491 1.504 1.218Z",
    fill: "#009B51"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "style-question_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5 .5)",
    d: "M0 0h16v16H0z"
  })))));
};
export { SvgStyleQuestion as ReactComponent };
export default __webpack_public_path__ + "84959e05e1900ad80bb3c169183f4d70.svg";